export enum SocketChannelsEnum {
  CHAT = "chat",
}
